import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const ButtonWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq.desktop} {
    margin-top: 0;
    margin-left: 8px;
    align-items: flex-end;
  }
`;

const KYCRetryButton = styled(ButtonPrimaryDark)`
  padding: 0 10px;
  flex-grow: 1;
  width: 100%;
  font-size: ${({ theme }) => theme.sizes.m};
  font-weight: ${({ theme }) => theme.fontWeights[500]};

  ${mq.desktop} {
    padding: 7px 19px;
    min-width: 160px;
    max-width: 160px;
  }
`;

export default {
  ButtonWrapper,
  KYCRetryButton,
};
